import {
  faGraduationCap,
  faList,
  faMedal,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { NavLink } from 'react-router-dom';
import NavbarBottomItem from './NavbarBottomItem';
import './bottomBar.css';

function NavbarBottom() {
  const fantaclasseBottomBarRoutes = [
    {
      name: 'Classe',
      icon: faGraduationCap,
      to: '/classe'
    },
    {
      name: 'Classifica',
      icon: faMedal,
      to: '/ranking'
    },
    {
      name: 'Attività',
      icon: faList,
      to: '/feed'
    },
    {
      name: 'Squadra',
      icon: faUsers,
      to: '/team'
    }
  ];

  return (
    <div className="bottom-bar pt-2">
      {fantaclasseBottomBarRoutes.map(route => (
        <NavLink
          key={route.name}
          to={route.to}
          className="text-600"
          style={{ textDecoration: 'none' }}
        >
          {({ isActive }) => {
            return (
              <NavbarBottomItem
                key={route.name}
                text={route.name}
                faIcon={route.icon}
                isActive={isActive}
              />
            );
          }}
        </NavLink>
      ))}
    </div>
  );
}

export default NavbarBottom;
